/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-12-11T09:46:08.795Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/identitySessionIdResponse
export const IdentitySessionIdResponseZod = z.object({
    id: z.string(),
});
export type IdentitySessionIdResponseType = z.TypeOf<typeof IdentitySessionIdResponseZod>;


// #/components/schemas/identityFinalizeRequest
export const IdentityFinalizeRequestZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    rawIdmidssionResult: z.string(),
});
export type IdentityFinalizeRequestType = z.TypeOf<typeof IdentityFinalizeRequestZod>;


// #/components/schemas/identityEkycVerificationResult
export const IdentityEkycVerificationResultZod = z.union([z.literal('success'), z.literal('failure'), z.literal('not-checked'), z.literal('cancelled')]);
export type IdentityEkycVerificationResultType = z.TypeOf<typeof IdentityEkycVerificationResultZod>;


// #/components/schemas/identityFinalizeResponse
export const IdentityFinalizeResponseZod = z.object({
    result: IdentityEkycVerificationResultZod,
    code: z.string(),
    status: z.string(),
    description: z.string(),
});
export type IdentityFinalizeResponseType = z.TypeOf<typeof IdentityFinalizeResponseZod>;


// #/components/schemas/identityEkycVerificationProgress
export const IdentityEkycVerificationProgressZod = z.union([z.literal('passed'), z.literal('requested'), z.literal('failed'), z.literal('not-checked'), z.literal('cancelled')]);
export type IdentityEkycVerificationProgressType = z.TypeOf<typeof IdentityEkycVerificationProgressZod>;


// #/components/schemas/identityVerificationVariant
export const IdentityVerificationVariantZod = z.union([z.literal('IdCard'), z.literal('IdCardProofOfAddress'), z.literal('IdCardAndFace'), z.literal('IdCardAndFaceProofOfAddress')]);
export type IdentityVerificationVariantType = z.TypeOf<typeof IdentityVerificationVariantZod>;


// #/components/schemas/identityVerificationProgressResponse
export const IdentityVerificationProgressResponseZod = z.object({
    id: z.number(),
    universe: z.string(),
    accountId: z.number(),
    progress: IdentityEkycVerificationProgressZod,
    rawResult: z.unknown(),
    createdAt: z.string(),
    finalizedAt: z.string().optional(),
    verificationVariant: IdentityVerificationVariantZod,
    triggerOrigin: z.string(),
    verificationResult: IdentityEkycVerificationResultZod,
    verificationIdStatus: IdentityEkycVerificationProgressZod,
    verificationPoaStatus: IdentityEkycVerificationProgressZod,
    verificationFaceStatus: IdentityEkycVerificationProgressZod,
});
export type IdentityVerificationProgressResponseType = z.TypeOf<typeof IdentityVerificationProgressResponseZod>;


// #/components/schemas/identityTriggerRequest
export const IdentityTriggerRequestZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    verificationVariant: IdentityVerificationVariantZod,
    triggerReason: z.string(),
});
export type IdentityTriggerRequestType = z.TypeOf<typeof IdentityTriggerRequestZod>;


// #/components/schemas/identityEmptyResponse
export const IdentityEmptyResponseZod = z.unknown();
export type IdentityEmptyResponseType = z.TypeOf<typeof IdentityEmptyResponseZod>;

